import { render, staticRenderFns } from "./allTicket.vue?vue&type=template&id=bd15a3a4&scoped=true"
import script from "./allTicket.vue?vue&type=script&lang=js"
export * from "./allTicket.vue?vue&type=script&lang=js"
import style0 from "./allTicket.vue?vue&type=style&index=0&id=bd15a3a4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd15a3a4",
  null
  
)

export default component.exports